import LoadingStatus from 'enums/loadingStatus';

const initialState = {
    isFetchingUnsubscribe: LoadingStatus.Idle,
    isFetchingUnsubscribeFeedback: LoadingStatus.Idle,
};

export default initialState;